exports.components = {
  "component---src-components-layouts-single-saga-js": () => import("./../../../src/components/layouts/single-saga.js" /* webpackChunkName: "component---src-components-layouts-single-saga-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-roadmap-js": () => import("./../../../src/pages/roadmap.js" /* webpackChunkName: "component---src-pages-roadmap-js" */),
  "component---src-pages-sagas-js": () => import("./../../../src/pages/sagas.js" /* webpackChunkName: "component---src-pages-sagas-js" */)
}

